import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Sun } from 'lucide-react';
import { EditorSection, Field } from '~/components/promotion/editor-section';
import { ImageUploader, type UploadedImage } from '~/components/image-uploader';
import { PolicyBadgeThumb } from '~/components/promotion/policy-badge-thumb';
import type { PromotionFormValues } from '~/lib/schemas/promotion';

function urlToImage(url: string | null): UploadedImage | null {
	return url ? { url, name: url.split('/').pop() ?? '', width: 0, height: 0, size: 0 } : null;
}

export function ImagesSection() {
	const { t } = useTranslation();
	const { control } = useFormContext<PromotionFormValues>();

	return (
		<EditorSection title={t('promotion.basicInfo.images.title')} subtitle={t('promotion.basicInfo.images.subtitle')}>
			<div className="grid grid-cols-2 gap-4">
				<Field label={t('promotion.basicInfo.images.badge')}>
					<Controller
						control={control}
						name="badgeImageUrl"
						render={({ field }) => (
							<ImageUploader
								value={urlToImage(field.value)}
								onChange={img => field.onChange(img?.url ?? null)}
								renderPreview={() => <PolicyBadgeThumb gradient="sun" icon={Sun} size="lg" />}
							/>
						)}
					/>
				</Field>
				<Field label={t('promotion.basicInfo.images.background')}>
					<Controller
						control={control}
						name="backgroundImageUrl"
						render={({ field }) => (
							<ImageUploader
								value={urlToImage(field.value)}
								onChange={img => field.onChange(img?.url ?? null)}
								helpText={t('promotion.basicInfo.images.backgroundHelp')}
							/>
						)}
					/>
				</Field>
			</div>
		</EditorSection>
	);
}
